export default __webpack_public_path__ + "static/media/gigadeflatonftmSLP.6bded94d.png";